import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import permission from './permission' // 权限
import vedioTeach from './help/vedio-teach' // 视频教程
import caseExplain from './help/case-explain' // 案例详解
import faq from './help/faq' // 常见问题
import updateLog from './help/update-log' // 更新日志
import helpDocCreate from './help/help-doc-create' // 新增数据公共弹窗

const debug = process.env.NODE_ENV !== 'production'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  modules: {
    permission,
    vedioTeach,
    helpDocCreate,
    caseExplain,
    faq,
    updateLog
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js